module.exports = __webpack_public_path__ + "img/e-com-solution-logo.3441e94b.png";